// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e903344","885":"52b647ec"}[chunkId] + ".chunk.js";
};